export default __webpack_public_path__ + "static/media/free-trial-end.e95c652c.gif";